
import moment from "moment";
import {login, logout, getMyProfil} from "../../API/API";
import { ensureSubscribe } from '../../sw/sw_subscribe';
import { getSwRegistration } from '../../sw/sw_registration';

//0000 39dfa55283318d31afe5a3ff4a0e3253e2045e43
//1337 77ba9cd915c8e359d9733edcfe9c61e5aca92afb
const initialState = {
    token: null,
    tokenNIP:null,
    NIP:null,
    attemptNIP: 0,
    isSignOut : false,
    isLoading: false,
    isInitialized: false,
};

export default function AuthReducer(state : any = initialState,action : any){
  const nextState = getNextState(state, action);

  // ensure justSignedIn is false if we did not just perform the sign in action
  if (nextState.justSignedIn && action !== "SIGN_IN") {
    return {...nextState, justSignedIn: false}
  }

  return nextState;
}


function getNextState(state : any = initialState,action : any){
    let nextState;
    switch (action.type){
        case 'RESTORE_TOKEN':
            nextState = _restoreToken(state,action);
            return nextState || state;
        case 'SIGN_IN':
            nextState = _signIn(state,action);
            return nextState || state;
        case 'SIGN_IN_NIP':
            nextState = _signInNIP(state,action);
            return nextState || state;
        case 'SIGN_OUT':
            nextState = _signOut(state,action);
            return nextState || state;
        case 'SIGN_OUT_NIP':
            nextState = _signOutNIP(state,action);
            return nextState || state;
        case 'SET_NIP':
            nextState = _setNIP(state,action);
            return nextState || state;
        case 'SET_ATTEMPT_NIP':
            nextState = _setAttemptNIP(state,action);
            return nextState || state;
        case 'SET_ACCOUNT':
            nextState = _setAccount(state,action);
            return nextState || state;
        case 'SET_INITIALIZED':
            nextState = _setInitialized(state,action);
            return nextState || state;
        default :
            return state;
    }
}


function _restoreToken(state : any,action : any){
    let nexState ={};
}

function _signIn(state : any,action : any){

   return {
        ...state,
        compte : action.value,
        isLoading : false,
        isSignOut : false,
        justSignedIn: true
    }
}

function _signOut(state : any,action : any){
  return {
      ...state,
      token : null,
      NIP : null,
      attemptNIP : 0,
      tokenNIP : null,
      isLoading : false,
      isSignOut : true,
      compte : null,
  }
}


function _signOutNIP(state : any,action : any){
    let nextState ={};
    nextState = {
        ...state,
        tokenNIP : null,
    }
    return nextState;
}


function _setAccount(state: any, action: any) {
  return {...state, compte: action.value};
}

function _setInitialized(state: any, action: any) {
  return {...state, isInitialized: action.value};
}

function _setNIP(state : any,action : any){
    let nextState ={};

    nextState = {
        ...state,
        NIP : {token : action.value,time : (new Date()).getTime()},
        isLoading : false,
        isSignOut : false
    }

    return nextState;
}

function _signInNIP(state : any,action : any){
    let nextState ={};
    nextState = {
        ...state,
        tokenNIP : action.value == null ? null : {token : action.value,time : (new Date()).getTime() + 15 *60000},
        attemptNIP : 0,
        isLoading : false,
        isSignOut : false
    }

    return nextState;
}

function _setAttemptNIP(state : any,action : any){
    let nextState ={};

    nextState = {
        ...state,
        attemptNIP : action.value,
        isLoading : false,
        isSignOut : false
    }

    return nextState;
}



export function signOut() {
  return (dispatch) => {
    return logout().then(() => {
      return dispatch({'type': 'SIGN_OUT', 'value': ""});
    });
  }
}

export function signIn(username, password) {
  return (dispatch) => {
    return login(username, password).then(data => {
      if (data !== false) {
	const wrapped_promise = () => {
	  return dispatch({'type': 'SIGN_IN', 'value': data});
	}

	// when signing in run subscription to push event (connected user is required)
	const current_registration = getSwRegistration();
	// if (current_registration) {
	if (false) {
	  return ensureSubscribe(current_registration).then(wrapped_promise);;
	} else {
	  return wrapped_promise();
	}
      }
      return Promise.reject();
    });
  }
}

export function fetchAccount() {
  return (dispatch) => {
    return getMyProfil().then(data => {
      if (data) {
        return dispatch({'type': 'SET_ACCOUNT', 'value': data});
      }
      return Promise.reject();
    })
  }
}

// try to fetch account (we will see if we are logged in), on fail, disconnect
export function initializeAccount() {
  return (dispatch) => {
    const setInitialized = () => {
       dispatch({'type': 'SET_INITIALIZED', value: true})
    }

    return dispatch(fetchAccount()).catch(() => {
      return dispatch(signOut())
    })
    .then(setInitialized).catch(setInitialized)
  }
}


